<template>
  <section class="explore-section">
    <div class="triplea-container">
      <div class="explore-title-row">
        <h2>Explore mais do mundo Apolar</h2>
      </div>
      <div class="explore-content-row">
        <div class="explore-content-posts-card">
          <div class="explore-content-posts-title-box">
            <h3>Ultimos posts </h3>
          </div>
          <div class="explore-content-posts-box">
            <div class="explore-content-post">
              <div class="explore-content-post-image-bloc">
                <img src="@/assets/img/triplea/home/blog/post-1.png">
              </div>
              <div class="explore-content-post-bloc">
                <div class="explore-content-text-wrapper">
                  <h4>Blog title heading will go here</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim...</p>
                </div>
                <div class="explore-content-text-details">
                  <small>5 min read</small>
                  <a href="">
                    Leia mais
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.70697 17.4492L15.414 11.7422L9.70697 6.03516L8.29297 7.44916L12.586 11.7422L8.29297 16.0352L9.70697 17.4492Z" fill="#333333"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="explore-content-post">
              <div class="explore-content-post-image-bloc">
                <img src="@/assets/img/triplea/home/blog/post-1.png">
              </div>
              <div class="explore-content-post-bloc">
                <div class="explore-content-text-wrapper">
                  <h4>Blog title heading will go here</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim...</p>
                </div>
                <div class="explore-content-text-details">
                  <small>5 min read</small>
                  <a href="">
                    Leia mais
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.70697 17.4492L15.414 11.7422L9.70697 6.03516L8.29297 7.44916L12.586 11.7422L8.29297 16.0352L9.70697 17.4492Z" fill="#333333"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="explore-content-text-card">
          <div class="explore-content-text-card-top">
            <div class="explore-content-text-card-icon-box">
              <img src="@/assets/img/triplea/home/diamond.svg">
            </div>
            <h3>
              Sua propriedade valorizada, <br/>
              seu patrimônio seguro.
            </h3>
          </div>
          <div class="explore-content-text-card-body">
            <p>Você tem um imóvel de alto padrão e deseja encontrar o cliente certo?</p>
            <p>A Apolar Triple A oferece uma abordagem diferenciada e exclusiva para garantir que seu imóvel receba a valorização que merece.</p>
            <p>Nossos especialistas estão prontos para conectar o seu patrimônio aos melhores interessados, sempre com agilidade, discrição e excelência.</p>
          </div>
          <div class="explore-content-text-card-footer">
            <button 
              class="explore-content-contact-button"
              @click="$bvModal.show('tripleaContactModal')"
            >
              Fale conosco
              <img src="@/assets/img/triplea/home/top-right-arrow-white.svg">
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import "@/assets/scss/custom/triplea/components/_home_explore_section.scss"
  export default {
    
  }
</script>


